<template>
    <a :href="this.$root.baseUrl + '/properties-for-sale'" class="cards-main__link blue-btn" >{{ 'View more' | trans }}</a>
</template>

<script>
export default {
    name: "GoToPropertiesButton"
}
</script>
